<div *ngIf="loading">
    <h5 class="text-primary-dark">Please wait...</h5>
</div>
<div *ngIf="!loading" class="content-height mb-8">
    <div class="d-flex justify-content-end align-items-center">
        <p class="text-muted text-smaller me-5">Max file size 5MB | Supported Formats: PDF, PNG, JPG, JPEG</p>
    </div>

    <div *ngIf="applicationsData">

        <div class="d-block d-md-none mobile-applications-container"
            *ngIf="applicationsData && applicationsData.length > 0">
            <label class="dropdown-label">Select University & Course:</label>
            <select class="mobile-app-dropdown" (change)="onMobileApplicationChange($event)">
                <option value="">Choose an application...</option>
                <ng-container *ngFor="let application of applicationsData; let appIndex = index">
                    <option *ngFor="let wish of application?.wishlist; let wishIndex = index"
                        [value]="appIndex + '-' + wishIndex">
                        {{wish?.courseName}} - {{wish?.universityName}} ({{application?.applicationId}})
                    </option>
                </ng-container>
            </select>
        </div>

        <!-- Mobile Selected Application Display -->
        <div class="d-block d-md-none selected-mobile-application-card" *ngIf="selectedMobileApplication">
            <div class="mobile-card-content">
                <div class="course-title">{{selectedMobileApplication?.wish?.courseName}}</div>
                <div class="university-name">{{selectedMobileApplication?.wish?.universityName}}</div>
                <div class="application-id">ID: {{selectedMobileApplication?.application?.applicationId}}</div>
            </div>
        </div>

        <!-- Mobile Document Limit Notice -->
        <div class="d-block d-md-none mobile-document-limit" *ngIf="selectedMobileApplication">
            <p class="limit-text">
                You can add up to 30 documents per university-course combination
            </p>
        </div>
        <!-- Mobile Documents Section for additionalRequests -->
        <!-- Mobile Documents Section for additionalRequests -->
        <div class="d-block d-md-none mobile-documents-area"
            *ngIf="selectedMobileApplication && selectedCategory === 'additionalRequests'">

            <ng-container
                *ngIf="getSelectedKey() && documentData?.additionalRequestsDocs?.[getSelectedKey()] | keyvalue as selectedDocs">
                <ng-container *ngIf="selectedDocs?.length > 0; else mobileNoAdditionalDocsTemplate">
                    <div class="mobile-additional-requests">
                        <ng-container *ngFor="let docType of selectedDocs">
                            <div class="mobile-request-card" *ngFor="let fileObj of docType.value; let i = index">
                                <div class="request-info">
                                    <p class="doc-name"><strong>Document Name:</strong> {{docType.key}}</p>
                                    <p class="doc-description"><strong>Description:</strong> {{fileObj?.description ||
                                        'N/A'}}</p>
                                </div>

                                <!-- Show upload button if no file -->
                                <div class="request-actions" *ngIf="!fileObj?.filePath">
                                    <button class="btn btn-outline-primary btn-sm"
                                        (click)="addNewDocument(docType.key, i, fileObj?.description)">Upload</button>
                                </div>

                                <!-- Show file details if file exists -->
                                <ng-container *ngIf="fileObj?.filePath">
                                    <p class="uploaded-by"><strong>Uploaded By:</strong> {{fileObj?.uploadedBy}}</p>
                                    <div class="file-row">
                                        <p class="file-name">{{fileObj?.fileName | slice:0:20}}...</p>
                                        <div class="file-actions">
                                            <button class="btn btn-primary btn-sm"
                                                (click)="downloadDocumentByS3Uri(fileObj?.filePath)">Download</button>
                                            <i class="bi bi-trash text-danger ms-3"
                                                (click)="removeFile(getSelectedKey(), docType.key)"
                                                title="Delete File"></i>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>

                <ng-template #mobileNoAdditionalDocsTemplate>
                    <div class="no-requests">
                        <p>No requested documents found.</p>
                    </div>
                </ng-template>
            </ng-container>

            <!-- Request Document Button for Mobile (Superadmin only) -->
            <div class="mobile-add-document" *ngIf="userDetails?.type === 'superadmin'">
                <button class="btn btn-primary btn-block" (click)="addNewDocument()">+ Request Document</button>
            </div>
        </div>

        <!-- Mobile Documents Section for uploadedByFA -->
        <div class="d-block d-md-none mobile-documents-area"
            *ngIf="selectedMobileApplication && selectedCategory === 'uploadedByFA'">

            <ng-container
                *ngIf="getSelectedKey() && documentData?.uploadedByFaDocs?.[getSelectedKey()] | keyvalue as selectedUniversityDocs">
                <ng-container *ngIf="selectedUniversityDocs?.length > 0; else mobileNoDocsTemplate">
                    <div class="mobile-fa-documents">
                        <ng-container *ngFor="let docType of selectedUniversityDocs">
                            <div class="mobile-document-card" *ngFor="let fileObj of docType.value">
                                <div class="document-info">
                                    <p class="doc-name"><strong>Document Name:</strong> {{docType.key}}</p>
                                    <p class="doc-description"><strong>Description:</strong> {{fileObj?.description ||
                                        'N/A'}}</p>
                                    <p class="uploaded-by"><strong>Uploaded By:</strong> {{fileObj?.uploadedBy}}</p>
                                </div>
                                <div class="file-row">
                                    <p class="file-name">{{fileObj?.fileName | slice:0:20}}...</p>
                                    <div class="file-actions">
                                        <button class="btn btn-primary btn-sm"
                                            (click)="downloadDocumentByS3Uri(fileObj?.filePath)">Download</button>
                                        <i class="bi bi-trash text-danger ms-3"
                                            (click)="removeFile(getSelectedKey(), docType.key)" title="Delete File"></i>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>

                <ng-template #mobileNoDocsTemplate>
                    <div class="no-documents">
                        <p>No documents available for {{selectedMobileApplication?.wish?.universityName}}.</p>
                    </div>
                </ng-template>
            </ng-container>

        </div>
        <!-- END MOBILE SECTION -->
        <div *ngIf="uploadByFaLoading || additionalRequestsLoading">
            <h6>Please wait...</h6>
        </div>

        <div *ngIf="!uploadByFaLoading && !additionalRequestsLoading">
            <div class="row position-relative bg-white">
                <div class="col-6 d-none d-md-block">
                    <div class="border border-1 rounded-1 p-2 height-custom position-relative">
                        <!-- Show this section when applications exist -->
                        <ng-container *ngIf="applicationsData && applicationsData.length > 0">
                            <div class="mb-4" *ngFor="let application of applicationsData">
                                <div class="h-100">
                                    <div *ngFor="let wish of application?.wishlist">
                                        <div class="application-card h-100"
                                            (click)="selectUniversityAndCourse(wish?.universityName, wish?.courseName)"
                                            [ngClass]="{'selected-university': selectedUniversity === wish?.universityName && selectedCourse === wish?.courseName}">
                                            <div class="row mb-2 ">
                                                <div class="col-12">
                                                    <div class="row justify-content-between">
                                                        <div class="col-md-9">
                                                            <h4 class="heading">{{wish?.courseName}}</h4>
                                                        </div>

                                                        <div class="col-md-3 justify-content-end d-flex">
                                                            <i class="bi bi-file-earmark me-2"></i>
                                                            <p>{{application?.applicationId}}</p>
                                                        </div>
                                                    </div>

                                                    <h5 class="university">{{wish?.universityName}}</h5>
                                                </div>
                                            </div>

                                            <div class="status-box mb-2">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <p class="status-label d-inline">Status: </p>
                                                        <p class="status-value d-inline">{{application?.status || 'Not
                                                            Assigned'}}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row align-items-center mt-2">
                                                <div class="d-flex">
                                                    <i class="bi bi-arrow-clockwise me-2"></i>
                                                    <p class="text-secondary mb-0">Last Activity -
                                                        {{application?.updatedAt | date:'MM/dd/yyyy h:mm a'}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Show this when no applications exist -->
                        <div *ngIf="!applicationsData || applicationsData.length === 0"
                            class="position-absolute top-50 start-50 translate-middle">
                            <h6 class="text-primary-dark text-center">No Applications Made Yet</h6>
                        </div>
                    </div>
                </div>


                <div *ngIf="selectedCategory === 'uploadedByFA'" class="col-6 position-relative d-none d-md-block">
                    <div class="border border-1 rounded-1 p-2 height-custom"
                        *ngIf="selectedUniversity && !notSelectedUniversity">
                        <p class="text-muted text-smaller text-center"> You can add upto 30 documents per university</p>
                        <div class="height-custom-document">
                            <ng-container
                                *ngIf="getSelectedKey() && documentData?.uploadedByFaDocs?.[getSelectedKey()] | keyvalue as selectedUniversityDocs; else noDocsTemplate">
                                <ng-container *ngIf="selectedUniversityDocs?.length > 0; else noDocsTemplate">
                                    <ng-container *ngFor="let docType of selectedUniversityDocs">
                                        <div class="mb-2">

                                            <div class="bg-light rounded roduned-1 p-2">
                                                <p class="fw-semibold mb-1">Document Name: <span
                                                        class="text-primary-dark fw-semibold">{{ docType?.key }}</span>
                                                </p>

                                                <ng-container *ngFor="let fileObj of docType.value; let i = index">
                                                    <p class="fw-semibold mb-1">Document Description: <span
                                                            class="text-primary-dark fw-semibold">{{
                                                            fileObj?.description || 'N/A' }}</span></p>

                                                    <p class="fw-semibold mb-1">Uploaded By: <span
                                                            class="text-primary-dark fw-semibold">{{ fileObj?.uploadedBy
                                                            }}</span></p>
                                                    <div
                                                        class="d-flex justify-content-between align-items-center me-4 bg-white border-1 rounded-1 p-2">
                                                        <div class="d-flex justify-content-start align-items-center">
                                                            <div>
                                                                <ng-container
                                                                    *ngIf="isImage(fileObj?.filePath); else fileTemplate">
                                                                    <div class="img-box-height">
                                                                        <ng-container
                                                                            *ngIf="fileObj?.filePath?.includes('public'); else privateImage">
                                                                            <img *ngIf="fileObj?.filePath"
                                                                                [src]="fileObj?.filePath"
                                                                                class="uploaded-image"
                                                                                alt="Preview Image" />
                                                                        </ng-container>
                                                                        <ng-template #privateImage>
                                                                            <div class="async-image-box">
                                                                                <fa-async-image
                                                                                    [src]="fileObj?.filePath"
                                                                                    [width]="'40'"
                                                                                    [styleClass]="'img img-fluid me-2 set-async-img-height'">
                                                                                </fa-async-image>
                                                                            </div>
                                                                        </ng-template>
                                                                    </div>
                                                                </ng-container>
                                                                <ng-template #fileTemplate>
                                                                    <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1682432634780pdf-1.png"
                                                                        class="uploaded-image-pdf ms-n3"
                                                                        alt="PDF Document" />
                                                                </ng-template>
                                                            </div>

                                                            <div class="row align-items-center mt-3">
                                                                <p [matTooltip]="fileObj?.fileName">
                                                                    {{ fileObj?.fileName | slice:0:20 }}...
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div class="d-flex justify-content-end align-items-center">
                                                            <button (click)="downloadDocumentByS3Uri(fileObj?.filePath)"
                                                                class="btn btn-primary btn-sm me-2">Download</button>
                                                            <i (click)="removeFile(getSelectedKey(), docType.key)"
                                                                class="bi bi-trash ms-3 text-danger"
                                                                title="Delete File"></i>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                            <ng-template #noDocsTemplate>
                                <h6 class="text-primary-dark text-center">No documents available for {{
                                    selectedUniversity }}.
                                </h6>
                            </ng-template>

                        </div>
                    </div>

                    <div *ngIf="notSelectedUniversity" class="">
                        <div class="position-absolute top-50 start-50 translate-middle">
                            <h6 class="text-primary-dark text-center">Please select atleast one university</h6>
                        </div>

                    </div>
                </div>


                <div *ngIf="selectedCategory === 'additionalRequests'"
                    class="col-6 position-relative d-none d-md-block">
                    <div class="border border-1 rounded-1 p-2 height-custom"
                        *ngIf="selectedUniversity && !notSelectedUniversity">
                        <p class="text-muted text-smaller text-center"> You can add up to 30 documents per
                            university-course combination</p>
                        <div class="height-custom-document">
                            <!-- Use composite key instead of selectedUniversity -->
                            <ng-container
                                *ngIf="getSelectedKey() && documentData?.additionalRequestsDocs?.[getSelectedKey()] | keyvalue as selectedDocs; else noDocsTemplate">
                                <ng-container *ngFor="let docType of selectedDocs">
                                    <div class="mb-2">
                                        <div class="bg-light rounded rounded-1 p-2">
                                            <ng-container *ngFor="let fileObj of docType.value; let i = index">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <p class="fw-semibold mb-1">Document Name: <span
                                                                class="text-primary-dark fw-semibold">{{ docType.key
                                                                }}</span></p>
                                                        <p class="fw-semibold mb-1">Document Description: <span
                                                                class="text-primary-dark fw-semibold">{{
                                                                fileObj?.description || 'N/A' }}</span></p>
                                                    </div>

                                                    <div class="d-flex justify-content-end align-items-center">
                                                        <div *ngIf="(!fileObj?.filePath) ">
                                                            <button
                                                                (click)="addNewDocument(docType.key, i, fileObj?.description)"
                                                                class="btn btn-outline-primary btn-sm me-2">Upload</button>
                                                        </div>

                                                        <div *ngIf="!fileObj?.filePath">
                                                            <button
                                                                class="btn btn-outline-gray disabled btn-sm me-2">Download</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <ng-container *ngIf="fileObj?.filePath">
                                                    <p class="fw-semibold mb-1">Uploaded By: <span
                                                            class="text-primary-dark fw-semibold">{{ fileObj?.uploadedBy
                                                            }}</span> </p>
                                                    <div
                                                        class="d-flex justify-content-between align-items-center me-4 bg-white border-1 rounded-1 p-2">
                                                        <div class="d-flex justify-content-start align-items-center">
                                                            <div>
                                                                <ng-container
                                                                    *ngIf="isImage(fileObj?.filePath); else fileTemplate">
                                                                    <div class="img-box-height">
                                                                        <ng-container
                                                                            *ngIf="fileObj?.filePath?.includes('public'); else privateImage">
                                                                            <img *ngIf="fileObj?.filePath"
                                                                                [src]="fileObj?.filePath"
                                                                                class="uploaded-image"
                                                                                alt="Preview Image" />
                                                                        </ng-container>
                                                                        <ng-template #privateImage>
                                                                            <div class="async-image-box">
                                                                                <fa-async-image
                                                                                    [src]="fileObj?.filePath"
                                                                                    [width]="'40'"
                                                                                    [styleClass]="'img img-fluid me-2 set-async-img-height'">
                                                                                </fa-async-image>
                                                                            </div>
                                                                        </ng-template>
                                                                    </div>
                                                                </ng-container>
                                                                <ng-template #fileTemplate>
                                                                    <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1682432634780pdf-1.png"
                                                                        class="uploaded-image-pdf ms-n3"
                                                                        alt="PDF Document" />
                                                                </ng-template>
                                                            </div>

                                                            <div class="row align-items-center mt-3">
                                                                <p [matTooltip]="fileObj?.fileName">
                                                                    {{ fileObj?.fileName | slice:0:20 }}...
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div class="d-flex justify-content-end align-items-center">
                                                            <button (click)="downloadDocumentByS3Uri(fileObj?.filePath)"
                                                                class="btn btn-primary btn-sm me-2">Download</button>
                                                            <i (click)="removeFile(getSelectedKey(), docType.key)"
                                                                class="bi bi-trash ms-3 text-danger"
                                                                title="Delete File"></i>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <!-- No Documents Template -->
                            <ng-template #noDocsTemplate>
                                <h6 class="text-primary-dark text-center">No requested documents found for {{
                                    selectedCourse }} at {{ selectedUniversity }}.</h6>
                            </ng-template>
                        </div>

                        <div *ngIf="userDetails?.type === 'superadmin' "
                            class="position-absolute bottom-0 start-50 translate-middle-x">
                            <button class="btn btn-primary rounded-1 mb-1" (click)="addNewDocument()">+ Request
                                Document</button>
                        </div>
                    </div>

                    <div *ngIf="notSelectedUniversity" class="">
                        <div class="position-absolute top-50 start-50 translate-middle">
                            <h6 class="text-primary-dark text-center">Please select at least one university</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!applicationsData" class="p-0">
        <aerp-base-schema-form *ngIf="data?.model && layout" [dataProcessor]="dataProcessor.bind(this)"
            [model]="data?.model" [layout]="layout" [dataModel]="dataModel" (onSubmit)="onSubmitResponse($event)">
        </aerp-base-schema-form>
    </div>
</div>